import template from './employeeDropdownList.html';
import controller from './employeeDropdownList.controller';
import './employeeDropdownList.scss';

let employeeDropdownListComponent = {
  restrict: 'E',
  bindings: {
    employees: '<',
    onSelectEmployee: '&',
    isDisabled: '<',
    enableAlert: '<',
    isMobileApp: '<',
    limitResults: '<',
  },
  template,
  controller
};

export default employeeDropdownListComponent;



// WEBPACK FOOTER //
// ./client/app/components/employeeDropdownList/employeeDropdownList.component.js